module.exports = __webpack_public_path__ + "satellite-selector.967d9c15d5fcb5252542.png";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/satellite-selector.png
// module id = ../../../../../src/assets/img/satellite-selector.png
// module chunks = main